import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { getCookie } from '@guardian/libs';
import { ShadyPie } from './ShadyPie';
import { WhenAdBlockInUse } from './WhenAdBlockInUse';
export const ContributionSlot = ({ shouldHideReaderRevenue, isPaidContent, }) => {
    const isSignedIn = !!getCookie({ name: 'GU_U', shouldMemoize: true });
    if (isPaidContent || shouldHideReaderRevenue || isSignedIn)
        return null;
    return (_jsx(WhenAdBlockInUse, { children: _jsx("div", Object.assign({ css: css `
					position: sticky;
					top: 0;
				` }, { children: _jsx(ShadyPie, {}, void 0) }), void 0) }, void 0));
};
